import request from '../utils/request';
const querystring = require('querystring')
 
//获取列表数据
export const fetchData = query => {  
    var list = request({
        url: 'comWxWork/selectPage.do',
        method: 'post',
        params: query
    }); 
    return list;
};
 


//启用-禁用 
export const changeStatus = query => {  
    var list = request({
        url: 'comWxWork/changeStatus.do',
        method: 'post',
        params: query
    }); 
    return list;
};

export const changeSure = query => {  
    var list = request({
        url: 'comWxWork/changeSure.do',
        method: 'post',
        params: query
    }); 
    return list;
};
 

export const fetchSelect = query => {  
    var list = request({
        url: 'comWxWork/getListFetch.do',
        method: 'post',
        params: query
    }); 
    return list;
};


//添加渠道信息
export const saveForm = query => {  
    var list = request({
        url: 'comWxWork/insert.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};

export const handDelete = query => {  
    var list = request({
        url: 'comWxWork/delete.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};

export const changeForm = query => {  
    var list = request({
        url: 'comWxWork/update.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};




 



